import Vue from "vue";
import Vuex from "vuex";
import * as EmailValidator from "email-validator";
import numbro from "numbro";
import ApiSimulador from './plugins/ApiSimulador';
// tslint:disable-next-line:no-var-requires
const numbroBR = require("numbro/languages/pt-BR");
numbro.registerLanguage((numbroBR as unknown) as numbro.NumbroLanguage);
numbro.setLanguage("pt-BR");

Vue.use(Vuex);

const fipeUrl = "https://api.fipeapi.com.br";
const apiKey = "81c3491bd83d67d9ad889cca166ea3d9";
const vitalicio = 0;

interface DadosErrors {
  nome?: boolean;
  email?: boolean;
  ddd?: boolean;
  telefone?: boolean;
  fipe?: boolean;
  marca?: boolean;
  modelo?: boolean;
  ano?: boolean;
}

export default new Vuex.Store({
  state: {
    cotacao: {
      id: undefined,
      protocolo: 0,
      nome: "",
      ddd: "",
      telefone: "",
      email: "",
      tipo: 3,
      marca: "",
      modelo: "",
      ano: "",
      combustivel: "",
      fipe_codigo: "",
      plano: "",
      valor_fipe: 0,
      valor_mensalidade: 150,
      valor_adesao: 350,
      cobertura: "R$ 100.000,00",
      valor_cobertura: 150,
      valor_danos_materiais: 30000,
      valor_danos_corporais: 30000,
      valor_danos_morais: 20000,
      valor_app: 20000,
      assistencia: 'nao',
      assistencia_label: 'Não',
      valor_assistencia: 0,
      assistencia_agregado: 0,
      valor_agregado: 0,
      guincho: 0,
      valor_guincho: 0,
    } as Cotacao,

    simulacao: {
      marca_id: "",
      modelo_id: "",
      ano_id: "",
      indicador: "",
      id_indicador: "",
    },

    validacao: false,
    errors: {},
    fipe: {} as FipeVeiculo,
    marcas: [],
    modelos: [],
    anos: [],

    loading_marcas: false,
    loading_modelos: false,
    loading_anos: false,
    loading_fipe: false,
    loaded_fipe: false,
    timestamp: Math.round(new Date().getTime() / 1000),
    origem_fipe: false,

    sidebar_enabled: false,
    sidebar_showing: false,
    history_button: true,

    configuracoes: {
    }
  },
  mutations: {
    SET_ID: ( state, payload ) => state.cotacao.id = payload,
    SET_PROTOCOLO: (state, payload) => state.cotacao.protocolo = parseInt(payload, 10),
    SET_COTACAO: (state, payload) => {
      const valorPlano = payload.valor_plano - vitalicio;
      payload.valor_plano = valorPlano;
      state.cotacao = payload;
    },
    SET_NOME: ( state, payload ) => state.cotacao.nome = payload,
    SET_EMAIL: ( state, payload ) => state.cotacao.email = payload,
    SET_DDD: ( state, payload ) => state.cotacao.ddd = payload,
    SET_TELEFONE: ( state, payload ) => state.cotacao.telefone = payload,

    SET_MARCA: (state, payload) => {
      state.simulacao.marca_id = payload.id;
      state.cotacao.marca = payload.name;
    },
    SET_MODELO: (state, payload) => {
      state.simulacao.modelo_id = payload.id;
      state.cotacao.modelo = payload.name;
    },
    SET_ANO: (state, payload) => {
      state.simulacao.ano_id = payload.id;
      state.cotacao.ano = payload.name;
    },
    SET_COMBUSTIVEL: (state, payload) => state.cotacao.combustivel = payload,
    SET_CODIGO_FIPE: (state, payload) => state.cotacao.fipe_codigo = payload,
    SET_VALOR_FIPE: (state, payload) => state.cotacao.valor_fipe = payload,
    SET_VALOR_MENSAL: (state, payload) => state.cotacao.valor_mensalidade = parseFloat(payload),
    SET_VALOR_ADESAO: (state, payload) => state.cotacao.valor_adesao = parseFloat(payload),

    SET_COBERTURA: (state, payload) => {
      state.cotacao.cobertura = payload.label;
      state.cotacao.valor_cobertura = payload.value;
      state.cotacao.valor_danos_materiais = payload.materiais;
      state.cotacao.valor_danos_corporais = payload.corporais;
      state.cotacao.valor_danos_morais = payload.morais;
      state.cotacao.valor_app = payload.app;
      state.cotacao.valor_adesao = payload.adesao;
    },

    SET_LISTA_MARCAS: (state, payload) => state.marcas = payload,
    SET_LISTA_MODELOS: (state, payload) => state.modelos = payload,
    SET_LISTA_ANOS: (state, payload) => state.anos = payload,
    SET_LOADING_MARCAS: (state, payload) => state.loading_marcas = payload,

    SET_LOADING_MODELOS: (state, payload) => state.loading_modelos = payload,
    SET_LOADING_ANOS: (state, payload) => state.loading_anos = payload,
    SET_LOADING_FIPE: (state, payload) => state.loading_fipe = payload,
    SET_LOADED_FIPE: (state, payload) => state.loaded_fipe = payload,
    SET_ORIGEM_FIPE: (state, payload) => state.origem_fipe = payload,
    SET_FIPE: (state, payload) => state.fipe = payload,

    SET_SIDEBAR_ENABLED: (state, payload) => state.sidebar_enabled = payload,
    SET_SIDEBAR_SHOWING: (state, payload) => state.sidebar_showing = payload,
    SET_HISTORY_ENABLED: (state, payload) => state.history_button = payload,

    SET_ASSISTENCIA: ( state, payload ) => {
      state.cotacao.assistencia = payload.key;
      state.cotacao.assistencia_label = payload.label;
      state.cotacao.valor_assistencia = payload.value;
      state.cotacao.valor_agregado = payload.agregado;
    },

    SET_AGREGADO: ( state, payload ) => state.cotacao.assistencia_agregado = payload,

    SET_GUINCHO: ( state, payload ) => {
      state.cotacao.guincho = payload === 0 ? 0 : 1;
      state.cotacao.valor_guincho = payload;
    },

    SET_ERRORS:       ( state, payload ) => state.errors = payload,
    ATIVAR_VALIDACAO: ( state ) => state.validacao = true,

  },
  getters: {
    show_sidebar ( state ) {
      return state.sidebar_enabled ? state.sidebar_showing : false;
    },
    veiculo_ano ( state ) {
      return state.cotacao.ano === "32000" ? "0 KM" : state.cotacao.ano;
    },
    valor_agregado ( state ) {
      if ( state.cotacao.assistencia_agregado === 0 || state.cotacao.valor_assistencia === 0 ) {
        return 0;
      }
      return state.cotacao.valor_agregado;
    },
    valor_mensalidade ( state, getters ) {
      return numbro(state.cotacao.valor_cobertura)
        .add(getters.valor_agregado)
        .add(state.cotacao.valor_assistencia)
        .add(state.cotacao.valor_guincho)
        .value();
    },
    valor_cortado ( state, getters ) {
      return numbro(getters.valor_mensalidade)
        .multiply(1.1)
        .value();
    },
    valor_anual( state, getters ) {
      return numbro(getters.valor_mensalidade)
        .multiply(11)
        .add(state.cotacao.valor_adesao)
        .value();
    },
    get_email ( state ) {
      if (EmailValidator.validate(state.cotacao.email)) {
        return state.cotacao.email;
      } else {
        return `${state.timestamp}@email.com`;
      }
    },
    cotacao(state, getters) {
      const cotacao = state.cotacao;

      cotacao.telefone = cotacao.telefone.replace(/\D/g, '');
      cotacao.valor_mensalidade = getters.valor_mensalidade;
      cotacao.valor_agregado = getters.valor_agregado;

      return cotacao;
    }
  },
  actions: {
    LOAD_COTACAO: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        ApiSimulador.get(payload).then((response) => {
          commit('SET_COTACAO', response.data);
          resolve();
        }).catch(() => {
          reject();
        });
      });
    },
    LOAD_MARCAS: ({ state, commit }) => {
      commit("SET_LOADING_MARCAS", true);
      return new Promise((resolve) => {
        fetch(`${fipeUrl}/v1/3?${apiKey}`)
          .then((data) => data.json())
          .then((data) => {
            commit("SET_LISTA_MARCAS", data);
            commit("SET_LOADING_MARCAS", false);
            resolve();
          });
      });
    },
    SET_MARCA: ({ state, commit }, payload) => {
      commit("SET_LOADING_MODELOS", true);
      commit("SET_MARCA", payload);
      return new Promise((resolve) => {
        fetch(`${fipeUrl}/v1/3/${state.simulacao.marca_id}?${apiKey}`)
          .then((data) => data.json())
          .then((data) => {
            commit("SET_LISTA_MODELOS", data);
            commit("SET_LOADING_MODELOS", false);
            resolve();
          });
      });
    },
    SET_MODELO: ({ state, commit }, payload) => {
      commit("SET_LOADING_ANOS", true);
      commit("SET_MODELO", payload);
      return new Promise((resolve) => {
        fetch(
          `${fipeUrl}/v1/3/${state.simulacao.marca_id}/${state.simulacao.modelo_id}?${apiKey}`
        )
          .then((data) => data.json())
          .then((data: any[]) => {
            data.forEach((value, index) => {
              const val = value.name.toString();
              data[index].label = val === "32000" ? "0 KM" : val;
            });
            commit("SET_LISTA_ANOS", data);
            commit("SET_LOADING_ANOS", false);
            resolve();
          });
      });
    },
    SET_ANO: ({ state, commit, dispatch }, payload) => {
      commit("SET_LOADING_FIPE", true);
      commit("SET_ANO", payload);
      return new Promise((resolve) => {
        const marca = state.simulacao.marca_id;
        const modelo = state.simulacao.modelo_id;
        const ano = state.simulacao.ano_id;
        fetch(`${fipeUrl}/v1/3/${marca}/${modelo}/${ano}?${apiKey}`)
          .then((data) => data.json())
          .then((data: any) => {
            commit("SET_CODIGO_FIPE", data.fipe_codigo);

            const preco = parseFloat(
              data.preco
                .replace("R$", "")
                .split(".")
                .join("")
                .replace(",", ".")
            );
            commit("SET_VALOR_FIPE", preco);
            commit("SET_FIPE", data);
            commit("SET_COMBUSTIVEL", data.combustivel);

            commit("SET_LOADING_FIPE", false);
            commit("SET_LOADED_FIPE", true);
          });
      });
    },
    FROM_COD_ANO({ state, commit, dispatch }, payload) {
      // Evita que consulte os dados novamente caso a pessoa volte a tela inicial
      if (!state.origem_fipe) {
        commit("SET_ORIGEM_FIPE", true);
        commit("SET_CODIGO_FIPE", payload.fipe);
        commit("SET_ANO", { id: `${payload.ano}-3`, name: payload.ano });
        fetch(`${fipeUrl}/v1/fipe/${payload.fipe}?${apiKey}`)
          .then((data) => data.json())
          .then((data: FipeVeiculo[]) => {

            data.forEach((item) => {
              if (item.id_modelo_ano === state.simulacao.ano_id) {
                commit("SET_MARCA", { id: item.id_marca, name: item.marca });
                commit("SET_MODELO", { id: item.id_modelo, name: item.name });
                commit("SET_MODELO", { id: item.id_modelo, name: item.name });

                const preco = parseFloat(
                  item.preco
                    .replace("R$", "")
                    .split(".")
                    .join("")
                    .replace(",", ".")
                );
                commit("SET_VALOR_FIPE", preco);
                commit("SET_FIPE", item);
                commit("SET_COMBUSTIVEL", item.combustivel);
                commit("SET_LOADING_FIPE", false);
                commit("SET_LOADED_FIPE", true);

              }
            });
          });
      }
    },
    VALIDAR_DADOS ( {state, commit}, payload ) {
      return new Promise( (resolve, reject) => {
        if ( payload ) {
          commit('ATIVAR_VALIDACAO');
        }
        if ( state.validacao ) {
          const errors: DadosErrors = {};
          if (state.cotacao.nome.length < 1) {
            errors.nome = true;
          }
          if (state.cotacao.ddd.length < 2) {
            errors.ddd = true;
          }
          if (state.cotacao.telefone.length < 9) {
            errors.telefone = true;
          }
          if (!state.loaded_fipe) {
            errors.fipe = true;
          }
          if (state.simulacao.marca_id === "") {
            errors.marca = true;
          }
          if (state.simulacao.modelo_id === "") {
            errors.modelo = true;
          }
          if (state.simulacao.ano_id === "") {
            errors.ano = true;
          }

          commit('SET_ERRORS', errors);

          if (Object.keys(errors).length > 0) {
            return reject();
          }
        }
        return resolve();
      });
    },
    VALIDAR_DADOS_FORM({ state, commit }) {
      return new Promise((resolve, reject) => {
        const errors: DadosErrors = {};
        if (state.simulacao.marca_id === "") {
          errors.marca = true;
        }
        if (state.simulacao.modelo_id === "") {
          errors.modelo = true;
        }
        if (state.simulacao.ano_id === "") {
          errors.ano = true;
        }

        commit("SET_ERRORS", errors);

        if (Object.keys(errors).length > 0) {
          return reject();
        }
        return resolve();
      });
    }
  }
});
